export const faqOpen = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const panes = document.querySelectorAll(
      ".tenesys-block-accordion .kt-accordion-pane",
    );

    const updatePane = (pane) => {
      const header = pane.querySelector(".kt-blocks-accordion-header");
      if (!header) return;

      const isOpen = header.getAttribute("aria-expanded") === "true";
      pane.classList.toggle("pane-active", isOpen);
    };

    panes.forEach((pane) => {
      const header = pane.querySelector(".kt-blocks-accordion-header");
      if (!header) return;

      // state at beginning
      updatePane(pane);

      const observer = new MutationObserver(() => {
        updatePane(pane);
      });

      observer.observe(header, {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });
    });
  });
};

// export const internalMenuClose = () => {
//   document.addEventListener("DOMContentLoaded", () => {
//     const panes = document.querySelectorAll(
//       ".tenesys-tablet-mobile-internal-menu .kt-accordion-pane",
//     );

//     panes.forEach((pane) => {
//       const header = pane.querySelector(".kt-blocks-accordion-header");
//       const content = pane.querySelector(".kt-accordion-panel-inner"); // kontener na linki

//       if (!header || !content) return;

//       const links = content.querySelectorAll('a[href*="#"]');

//       links.forEach((link) => {
//         link.addEventListener("click", () => {
//           const isOpen = header.getAttribute("aria-expanded") === "true";

//           if (isOpen) {
//             header.click();
//           }
//         });
//       });
//     });
//   });
// };

export const internalMenuClose = () => {
  document.addEventListener("DOMContentLoaded", () => {
    // 1. Selektory
    const menuContainer = document.querySelector(".tenesys-desktop-internal-menu");
    if (!menuContainer) return;

    const links = menuContainer.querySelectorAll('a[href*="#"]');
    const sections = [];

    // Pobieramy sekcje, do których prowadzą linki
    links.forEach(link => {
      const id = link.getAttribute("href").split("#")[1];
      const section = document.getElementById(id);
      if (section) sections.push({ link, section });
    });

    // 2. Funkcja ustawiająca klasę aktywną
    const makeActive = (link) => {
      links.forEach(l => l.classList.remove("el-active"));
      link.classList.add("el-active");
    };

    // 3. Scroll Spy - Logika śledzenia scrolla
    const spyScroll = () => {
      const scrollPos = window.scrollY || document.documentElement.scrollTop;
      
      // Dodajemy offset (np. 100px), żeby aktywowało się nieco przed dotarciem do samej góry
      const offset = 150; 

      sections.forEach(({ link, section }) => {
        if (
          section.offsetTop <= scrollPos + offset &&
          section.offsetTop + section.offsetHeight > scrollPos + offset
        ) {
          makeActive(link);
        }
      });
    };

    // 4. Obsługa kliknięcia (Twoja poprzednia logika + zaznaczanie)
    const panes = document.querySelectorAll(".tenesys-tablet-mobile-internal-menu .kt-accordion-pane");

    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        // Natychmiastowe zaznaczenie po kliku
        makeActive(link);

        // Logika dla akordeonu (mobile)
        const pane = link.closest(".kt-accordion-pane");
        if (pane) {
          const header = pane.querySelector(".kt-blocks-accordion-header");
          if (header && header.getAttribute("aria-expanded") === "true") {
            header.click();
          }
        }
      });
    });

    // Nasłuchiwanie scrolla
    window.addEventListener("scroll", spyScroll);
    // Odpal raz na starcie
    spyScroll();
  });
};